import { Injectable } from '@angular/core'
import { Action, Store } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import * as SelectedAuctionSelectors from './selected-auction.selectors'

import { SelectedAuctionState } from './selected-auction.reducer'
import { map } from 'rxjs'
import { SharedAuctionFacade } from 'libs/shared/models/auction/auction.models'

@Injectable({
  providedIn: 'root',
})
export class SelectedAuctionFacade implements GbBaseFacade, SharedAuctionFacade {
  loaded$ = this.store.select(SelectedAuctionSelectors.selectLoaded)
  saving$ = this.store.select(SelectedAuctionSelectors.selectSaving)
  saved$ = this.saving$.pipe(map((saving) => !saving)) // for buttons expecting "loaded", would be good to update to "loading" instead at some point
  auction$ = this.store.select(SelectedAuctionSelectors.selectAuction)
  urlName$ = this.store.select(SelectedAuctionSelectors.selectUrlName)
  auctionCurrency$ = this.store.select(SelectedAuctionSelectors.selectCurrency)
  auctionCountry$ = this.store.select(SelectedAuctionSelectors.selectCountry)
  isSaas$ = this.store.select(SelectedAuctionSelectors.selectIsSaas)
  banners$ = this.store.select(SelectedAuctionSelectors.selectBanners)
  invoiceImage$ = this.store.select(SelectedAuctionSelectors.selectInvoiceImage)
  isRaffleEnabled$ = this.store.select(SelectedAuctionSelectors.selectIsRaffleEnabled)
  isTicketingEnabled$ = this.store.select(SelectedAuctionSelectors.selectIsTicketingEnabled)
  enablePaddleNumbers$ = this.store.select(SelectedAuctionSelectors.selectIsPaddleNumbersEnabled)
  isBothEmailPhoneAllowed$ = this.store.select(SelectedAuctionSelectors.selectIsBothEmailPhoneAllowed)
  clientAccount$ = this.store.select(SelectedAuctionSelectors.selectClientAccount)
  commissionPercentage$ = this.store.select(SelectedAuctionSelectors.selectCommissionPercentage)
  hasRequestInvoicePaymentMethod$ = this.store.select(SelectedAuctionSelectors.selectHasRequestInvoicePaymentMethod)
  preBiddingEnabled$ = this.store.select(SelectedAuctionSelectors.selectPreBiddingEnabled)
  paddleNumbersRequirePaymentMethod$ = this.store.select(
    SelectedAuctionSelectors.selectPaddleNumberRequirePaymentMethod,
  )
  capturePhoneNumbers$ = this.store.select(SelectedAuctionSelectors.selectCapturePhoneNumbers)
  captureTermsAndConditions$ = this.store.select(SelectedAuctionSelectors.selectCaptureTermsAndConditions)
  isAuctionHidden$ = this.store.select(SelectedAuctionSelectors.selectIsAuctionHidden)
  preAuthAtReg$ = this.store.select(SelectedAuctionSelectors.selectCreditCardPreAuthAtReg)
  teamsCount$ = this.store.select(SelectedAuctionSelectors.selectTeamsCount)
  captureTeams$ = this.store.select(SelectedAuctionSelectors.selectCaptureTeams)
  eventTicketCaptureEmail$ = this.store.select(SelectedAuctionSelectors.selectEventTicketCaptureEmail)
  eventTicketCapturePhoneNumber$ = this.store.select(SelectedAuctionSelectors.selectEventTicketCapturePhoneNumber)
  ticketsLabel$ = this.store.select(SelectedAuctionSelectors.selectTicketsLabel)
  paddleStartNumber$ = this.store.select(SelectedAuctionSelectors.selectPaddleStartNumber)
  metadata$ = this.store.select(SelectedAuctionSelectors.selectMetadata)
  stripeUserId$ = this.store.select(SelectedAuctionSelectors.stripeUserId)
  isStripeExpress$ = this.store.select(SelectedAuctionSelectors.isStripeExpress)
  tippingSliderAmountOptions$ = this.store.select(SelectedAuctionSelectors.tippingSliderAmountOptions)

  constructor(private store: Store<SelectedAuctionState>) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
